module.exports = __webpack_public_path__ + "static/media/menu-advanced.7f2d3f7f.svg";